module.exports = __webpack_public_path__ + "img/IT0000532321047.0775e463.png";